import { Box } from 'native-base'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ErrorImage } from '../../components/images/Error'
import { ReferralImage } from '../../components/images/Referral'

import { REDIRECTION_REASON_REFERRAL, REDIRECTION_REASON_REFERRAL_ERROR } from './redirect-reasons'

export const WelcomeImageError = () => (
  <Box mt={4} mb={7}>
    <ErrorImage />
  </Box>
)

export const WelcomeImage = ({ redirectionReason }: { redirectionReason?: string }) => {
  const { t } = useTranslation()

  if (redirectionReason === REDIRECTION_REASON_REFERRAL) {
    return <ReferralImage alt={t('screens.referral.loggedIn.heading')} />
  }

  if (redirectionReason === REDIRECTION_REASON_REFERRAL_ERROR) {
    return <WelcomeImageError />
  }

  return null
}
